const consumptionUnits = {
  electric: ['kwh'],
  gas: ['ccf', 'cf', 'mcf', 'mmbtu', 'therms', 'dth'],
  water: ['ccf', 'cf', 'gal', 'kgal'],
  propane: ['gal', 'kbtu', 'mmbtu'],
  production: ['-'],
};

export default consumptionUnits;

export const UNIT_UTILITIES = ['gas', 'propane', 'water'];

export const ET_FRONTEND_CONVERSIONS = {
  "electric": { 'kWh': 1 },
  "gas": {
    "ccf": 1,
    "cf": 100,
    "mcf": 0.01,
    "mmbtu": 0.102,
    "therms": 1.02,
    "dth": 0.102
  },
  "water": {
    "ccf": 1,
    "cf": 100,
    "gal": 748.052,
    "kgal": 0.748052
  },
  "propane": {
    "gal": 1,
    "kbtu": 91.547,
    "mmbtu": 0.091547
  }
}